import Typography from "@mui/material/Typography";

import ActionRequiredChip from "@app/analytics/components/ActionRequiredChip";
import ActiveChip from "@app/analytics/components/ActiveChip";
import IntegrationProviderIcon from "@app/analytics/components/IntegrationProviderIcon";
import { getCategoryLabel } from "@app/analytics/Integrations/utils";
import type { Integration } from "@app/common/types";

import { Column, Row } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

import { AddButton, InnerContainer, OuterContainer } from "./styles";
import { CategoryLabel, PremiumChip } from "../styles";

export interface IntegrationItemProps {
  description: string;
  isSelected?: boolean;
  onAdd?: () => void;
  onClick?: (route: string) => void;
  provider: Integration;
  tooltip?: string;
}

const IntegrationItem = ({
  description,
  isSelected = false,
  onAdd,
  onClick,
  provider,
  tooltip,
}: IntegrationItemProps) => {
  return (
    <OuterContainer>
      <TooltipWrapper
        show={provider.isDisabled}
        title={tooltip}
        wrapperSx={{ width: "100%" }}
        placement="right"
      >
        <InnerContainer
          disabled={provider.isDisabled}
          selected={isSelected}
          spacing={1.5}
          onClick={isSelected ? undefined : () => onClick?.(provider.route)}
        >
          <Column>
            <IntegrationProviderIcon src={provider.icon} />
          </Column>
          <Column spacing={0.5} flex={1}>
            <Row variant="apart" spacing={1} width="100%">
              <Typography variant="bodyPrimaryMed">
                {provider.displayName}
              </Typography>
              {provider.isDisabled ? (
                <Typography variant="labelMed" color="shades.neutral.600">
                  Not available
                </Typography>
              ) : provider.limitedData ? (
                <ActionRequiredChip
                  label={
                    provider.reauthRequired ? "Action Needed" : "Limited Data"
                  }
                  severity="warning"
                />
              ) : provider.reauthRequired ? (
                <ActionRequiredChip severity="error" />
              ) : provider.isConnected ? (
                <ActiveChip />
              ) : onAdd ? (
                <AddButton onClick={onAdd} />
              ) : null}
            </Row>
            <Row variant="left" spacing={0.5}>
              <CategoryLabel>
                {getCategoryLabel(provider.category)}
              </CategoryLabel>
              {provider.isPremium && <PremiumChip />}
            </Row>
            <Typography variant="labelReg" color="shades.neutral.600">
              {description}
            </Typography>
          </Column>
        </InnerContainer>
      </TooltipWrapper>
    </OuterContainer>
  );
};

export default IntegrationItem;
